import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/services/global.service';

@Component({
    selector: 'sd-custom-dialog',
    templateUrl: './custom-dialog.component.html',
    styleUrls: ['./custom-dialog.component.scss']
})
export class CustomDialogComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<CustomDialogComponent>,
        public global: GlobalService,
        public router: Router,
    ) { }

    ngOnInit() {
    }

    closeDialog() {
        // this.global.trackEvent('Login', 'Close', this.from + '-' + this.type);
        this.dialogRef.close('');
    }

    uploadMore(isreleased) {
        if (!isreleased) {
            this.router.navigate(
                ['upload/tracks'],
            )
        } else {
            this.router.navigate(['/distribute'])
        }
    }


}
